import { METODOS_ENTREGA, USUARIOS_TICOLITAS } from "./constants";

const STAFF_ROLES = new Set([
  "admin",
  "dependiente",
  "bodega",
  "mensajero",
  "administradorTienda",
  "administradorInventario",
  "integracionSistema",
  "superAdmin",
]);

function normalizeRoles(roles) {
  if (!roles) {
    return [];
  }
  if (Array.isArray(roles)) {
    return roles;
  }
  return String(roles)
    .split(",")
    .map((role) => role.trim())
    .filter(Boolean);
}

export function isUsuarioColaborador(usuario, idUsuario) {
  const userId = idUsuario ?? usuario?.id;
  if (userId && USUARIOS_TICOLITAS.includes(userId)) {
    return true;
  }
  if (!usuario) {
    return false;
  }
  if (usuario.apellido1 === "TiColitas") {
    return true;
  }
  if (usuario.email && /@ticolitas\.com$/i.test(usuario.email)) {
    return true;
  }
  return normalizeRoles(usuario.roles).some((role) => STAFF_ROLES.has(role));
}

export function getNombreUsuario(usuario) {
  if (!usuario?.nombre) {
    return null;
  }
  return `${usuario.nombre}${usuario.apellido1 ? ` ${usuario.apellido1}` : ""}`;
}

export function getNombreClienteEntrega(venta) {
  if (venta?.nombreCompletoEntrega) {
    return venta.nombreCompletoEntrega;
  }
  if (venta?.idMetodoEntrega === METODOS_ENTREGA.LOCAL) {
    return DEFAULT_NOMBRE_ENTREGA_LOCAL;
  }
  if (isUsuarioColaborador(venta?.usuario, venta?.idUsuario)) {
    return "Cliente no identificado";
  }
  return getNombreUsuario(venta?.usuario) || "Cliente no identificado";
}

export const DEFAULT_NOMBRE_ENTREGA_LOCAL = "Cliente en tienda";
export const DEFAULT_TELEFONO_ENTREGA_LOCAL = "88888888";

export function resolveDatosClienteEntregaLocal(
  nombre,
  telefono,
  codigoPais = 506
) {
  const nombreTrim = String(nombre || "").trim();
  const telefonoDigits = String(telefono || "").replace(/\D/g, "");
  return {
    nombreCompletoEntrega: nombreTrim || DEFAULT_NOMBRE_ENTREGA_LOCAL,
    telefono:
      telefonoDigits.length >= 8
        ? telefonoDigits
        : DEFAULT_TELEFONO_ENTREGA_LOCAL,
    codigoPaisTelefono: codigoPais || 506,
  };
}

export function requiereDatosClienteEntrega(usuario, shippingMethod, idUsuario) {
  return (
    shippingMethod &&
    !shippingMethod.requiereDireccion &&
    !shippingMethod.esLocal &&
    isUsuarioColaborador(usuario, idUsuario)
  );
}

export function validarDatosClienteEntrega(nombre, telefono) {
  const errors = [];
  if (!nombre || !String(nombre).trim()) {
    errors.push({
      message:
        'Por favor completá el nombre completo del cliente en la sección de "Entrega"',
      inputId: "clienteEntregaNombre",
    });
  }
  if (!telefono || String(telefono).replace(/\D/g, "").length < 8) {
    errors.push({
      message:
        'Por favor ingresá un teléfono válido del cliente (mínimo 8 dígitos) en la sección de "Entrega"',
      inputId: "clienteEntregaTelefono",
    });
  }
  return errors;
}

export function getTelefonoClienteEntrega(venta) {
  if (venta?.telefono) {
    return {
      telefono: venta.telefono,
      codigoPaisTelefono: venta.codigoPaisTelefono,
    };
  }
  if (isUsuarioColaborador(venta?.usuario, venta?.idUsuario)) {
    return null;
  }
  if (venta?.usuario?.telefono) {
    return {
      telefono: venta.usuario.telefono,
      codigoPaisTelefono: venta.usuario.codigoPaisTelefono,
    };
  }
  return null;
}
